import React from 'react';

import {MobileMenu} from '../HeaderMobileMenu/HeaderMobileMenu';
import {HeaderLogo} from '../HeaderLogoBlock/HeaderLogoBlock';
import {HeaderMenu} from '../HeaderMenu/HeaderMenu';
import {HeaderActions} from '../HeaderActions/HeaderActions';

export default function HeaderLayoutCenter({ links, item_count = '', settings }) {
    return (
        <div className={`w-full flex items-center lg:items-${settings.section.header_text_position_desktop} relative`}>
            <div className={'mobile-menu-container lg:hidden'}>
                <MobileMenu link_list={links} settings={settings}/>
            </div>

            <div className={'hidden lg:block flex-grow lg:basis-1/3'}>
                <HeaderMenu link_list={links} settings={settings}/>
            </div>

            <div className={'flex relative justify-center flex-grow-0 basis-1/3'}>
                <HeaderLogo settings={settings} className={''}/>
            </div>

            <div className="flex items-center justify-end header-toolbar flex-grow lg:basis-1/3">
                <HeaderActions item_count={item_count} settings={settings}/>
            </div>
        </div>
    );
}